<script>
	import config from "../config/config.json";
	import { jwt } from "../stores/jwtstore";
	import { displaySuccessfulBookingNotif } from "../stores/displaynotification";
	import { navigate } from "svelte-routing";
	import { onMount, onDestroy } from "svelte";
	import { FETCHING, FETCHED, NOT_FETCHING } from "../config/const.js";
	import { getDate, getTime } from "../helpers.js";
	import {
		DatePicker,
		DatePickerInput,
		Grid,
		Row,
		Column,
		Button,
		Loading,
		InlineNotification,
		DataTable,
		Toolbar,
		ToolbarBatchActions,
		ToolbarContent,
	} from "carbon-components-svelte";

	import TrashCan32 from "carbon-icons-svelte/lib/TrashCan32/TrashCan32.svelte";
	import Edit32 from "carbon-icons-svelte/lib/Edit32/Edit32.svelte";

	import { DateTime } from "luxon";

	let entriesQueryStatus = NOT_FETCHING,
		entriesQueryPromise,
		deleteEntriesQueryPromise,
		deleteEntriesQueryStatus = NOT_FETCHING,
		deleteEntriesQueryErrors = [];
	let queryRes;

	let jwt_value;
	let displaySuccessfulBookingNotif_value;

	const jwt_unsub = jwt.subscribe((value) => {
		jwt_value = value;
	});

	const displaySuccessfulBookingNotif_unsub =
		displaySuccessfulBookingNotif.subscribe((value) => {
			displaySuccessfulBookingNotif_value = value;
		});

	let selectedRowIds = [];

	let now = DateTime.local();

	let yearbefore = now.plus({ years: -1 }).toJSDate();
	let yearafter = now.plus({ years: 1 }).toJSDate();
	let yearafterluxon = now.plus({ years: 1 });
	let monthbefore = now.plus({ months: -1 });
	let monthafter = now.plus({ months: 1 });


	let datePickerRef;

	let startComponent;
	let endComponent;

	const {
		root,
		endpoints: { getentries, delentries },
	} = config;

	let query = {};

	let errors = {
		start_time: {
			isset: false,
		},
		end_time: {
			isset: false,
		},
	};

	onMount(() => {
		startComponent.value = now.toFormat("dd/LL/y");
		endComponent.value = yearafterluxon.toFormat("dd/LL/y");
		query.start_time = Math.floor(now.toSeconds());
		query.end_time = Math.floor(yearafterluxon.toSeconds());
		formsubmit();
	});

	onDestroy(() => {
		displaySuccessfulBookingNotif.set(false);
		displaySuccessfulBookingNotif_unsub();
		jwt_unsub();
	});

	const setquerydate = (e) => {
		const [start, end] = e.detail.selectedDates;
		if (start) {
			query.start_time = start.getTime() / 1000;
		}
		if (end) {
			query.end_time = end.getTime() / 1000;
		}
	};

	const getEntriesRequest = async () => {
		errors = Object.keys(errors).reduce((acc, val) => {
			return { ...acc, [val]: { isset: false } };
		}, {});
		const url = "http://" + root + getentries;

		if (!query.start_time) {
			query.start_time = monthbefore.toSeconds();
		}
		if (!query.end_time) {
			query.end_time = monthafter.toSeconds();
		}

		entriesQueryStatus = FETCHING;

		try {
			query.jwt = jwt_value;
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify(query),
			});

			let body = await response.json();

			if (!response.ok) {
				if (body.type === "invalid" || body.type === "missing") {
					if (body.field == "jwt") {
						jwt.set("");
					}
					errors[body.field].isset = true;
					errors[body.field].description = body.description;
					throw new Error("Requête invalide");
				}
				if (
					body.error.type === "QUERY" ||
					body.error.type === "DATABASE"
				) {
				}
				throw new Error(body.error.description);
			}
			entriesQueryStatus = FETCHED;
			body = body.map((v, id) => {
				return {
					...v,
					start_time: new DateTime.fromSeconds(
						parseInt(v.start_time)
					),
					end_time: new DateTime.fromSeconds(parseInt(v.end_time)),
					id: id,
				};
			});
			queryRes = body.sort(
				({ start_time: start_timeA }, { start_time: start_timeB }) => {
					return start_timeB - start_timeA;
				}
			);
			return queryRes;
		} catch (e) {
			queryRes = [];
			if (e.name === "TypeError") {
				throw new Error("Impossible de contacter le serveur");
			}
			throw e;
		}
	};

	const formsubmit = (event) => {
		errors = Object.keys(errors).reduce((acc, val) => {
			return { ...acc, [val]: { isset: false } };
		}, {});
		entriesQueryPromise = getEntriesRequest();
	};

	const delEntriesRequest = async (entry) => {
		const url = "http://" + root + delentries;

		let delEntriesQuery = { entry_id: entry.entry_id, jwt: jwt_value };

		try {
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify(delEntriesQuery),
			});

			const body = await response.json();

			if (!response.ok) {
				if (body.type === "invalid" || body.type === "missing") {
					if (body.field == "jwt") {
						jwt.set("");
					}
					throw new Error("Requête invalide");
				}
				if (
					body.error.type === "QUERY" ||
					body.error.type === "DATABASE" ||
					body.error.type === "ARBITRARAYERROR"
				) {
					throw new Error(body.error.description);
				}
			}
			if (body.delete != "ok") {
				throw new Error("Erreur Inconnue");
			}
		} catch (e) {
			if (e.name === "TypeError") {
				throw new Error("Impossible de contacter le serveur");
			}
			throw new Error(`${entry.name}, ${e.message}`);
		}
	};

	const batchActionsClick = async () => {
		const entries = await entriesQueryPromise;
		console.log(entries);
		if (selectedRowIds.length > 0) {
			const entryids = selectedRowIds.map((id) => {
				return entries[id];
			});
			console.log(entryids);
			deleteMultiple(entryids);
		}
		selectedRowIds = [];
	};

	const deleteMultiple = async (entryids) => {
		deleteEntriesQueryErrors = [];
		deleteEntriesQueryStatus = FETCHING;
		const promises = entryids.map((entry_id) =>
			delEntriesRequest(entry_id)
		);
		deleteEntriesQueryPromise = Promise.allSettled(promises);
		await deleteEntriesQueryPromise;
		formsubmit();
	};

	const deletesingle = async (row) => {
		deleteMultiple([row]);
	};
	const edit = (row) => {
		console.log(row);
	};

	const dateDisplay = (date) => {
		return date.toLocaleString(DateTime.DATETIME_FULL);
	};

	let headers = [
		{
			key: "start_time",
			value: "Heure de début",
			display: dateDisplay,
			sort: (a, b) => {
				return a - b;
			},
		},
		{
			key: "end_time",
			value: "Heure de fin",
			display: dateDisplay,
			sort: (a, b) => {
				return a - b;
			},
		},
		{ key: "name", value: "Nom de la réunion" },
		{ key: "room_name", value: "Nom de la salle" },
		{ key: "invites", value: "Invités" },
		// { key: "overflow", empty: true },
		// { key: "editbutton", empty: true },
		{ key: "buttons", empty: true },
	];
	// TODO : Implémenter la pagination avec + le sort
</script>

<Grid fullWidth>
	{#if displaySuccessfulBookingNotif_value}
		<Row padding>
			<Column
				sm={{ span: 4, offset: 0 }}
				md={{ span: 4, offset: 2 }}
				lg={{ span: 8, offset: 4 }}
				xlg={{ span: 8, offset: 4 }}
				max={{ span: 8, offset: 4 }}
			>
				<InlineNotification
					lowContrast
					kind="success"
					title="Succès:"
					subtitle="Votre reservation a bien été prise en compte"
					on:close={() => displaySuccessfulBookingNotif.set(false)}
				/>
			</Column>
		</Row>
	{/if}
	<form name="entriesform" on:submit|preventDefault={formsubmit}>
		<!--Pour le moment impossible de récupérer la valeur des deux inputs via un binding. Voir: https://github.com/IBM/carbon-components-svelte/issues/234-->
		<Row padding>
			<Column
				sm={{ span: 4, offset: 0 }}
				md={{ span: 4, offset: 2 }}
				lg={{ span: 8, offset: 4 }}
				xlg={{ span: 8, offset: 4 }}
				max={{ span: 8, offset: 4 }}
			>
				<DatePicker
					bind:ref={datePickerRef}
					on:change={setquerydate}
					value={monthbefore.toJSDate()}
					style="justify-content: center; align-items: center;"
					dateFormat="d/m/Y"
					datePickerType="range"
					minDate={yearbefore}
					maxDate={yearafter}
					locale="fr"
				>
					<DatePickerInput
						bind:invalid={errors.start_time.isset}
						bind:ref={startComponent}
						value={monthbefore.toJSDate()}
						id="date-picker-range-start"
						placeholder="dd/dd/yyyy"
						labelText="Date de début"
						type="text"
					/>
					<DatePickerInput
						bind:invalid={errors.end_time.isset}
						bind:ref={endComponent}
						value={monthafter.toJSDate()}
						id="date-picker-range-end"
						placeholder="mm/dd/yyyy"
						labelText="Date de fin"
						type="text"
					/>
				</DatePicker>
			</Column>
		</Row>
		<Row padding>
			<Column
				align="center"
				sm={{ span: 4, offset: 0 }}
				md={{ span: 4, offset: 2 }}
				lg={{ span: 8, offset: 4 }}
				xlg={{ span: 8, offset: 4 }}
				max={{ span: 8, offset: 4 }}
			>
				<Button kind="primary" type="submit"
					>Chercher dans mes réunions</Button
				>
			</Column>
		</Row>
		<!-- On peut imaginer un truc du style "if decoded_jwt.admin === true then <TextInput username />"  -->
	</form>
	{#if deleteEntriesQueryStatus != NOT_FETCHING}
		<Row padding>
			<Column
				align="center"
				sm={{ span: 4, offset: 0 }}
				md={{ span: 8, offset: 0 }}
				lg={{ span: 14, offset: 1 }}
				xlg={{ span: 14, offset: 1 }}
				max={{ span: 14, offset: 1 }}
			>
				{#await deleteEntriesQueryPromise}
					<Loading description="Active loading indicator" />
				{:then promisesRes}
					{#each promisesRes as { status, reason }}
						{#if status === "rejected"}
							<InlineNotification
								lowContrast
								kind="error"
								title="Error"
								subtitle="Impossible de supprimer certaines réunions: {reason.message}"
							/>
						{/if}
					{/each}
				{:catch error}
					<InlineNotification
						lowContrast
						kind="error"
						title="Error"
						subtitle="Une erreur inconnue est survenue"
						caption={new Date().toLocaleString()}
					/>
				{/await}
			</Column>
		</Row>
	{/if}
	{#if entriesQueryStatus != NOT_FETCHING}
		<Row padding>
			<Column
				align="center"
				sm={{ span: 4, offset: 0 }}
				md={{ span: 8, offset: 0 }}
				lg={{ span: 14, offset: 1 }}
				xlg={{ span: 14, offset: 1 }}
				max={{ span: 14, offset: 1 }}
			>
				{#await entriesQueryPromise}
					<Loading description="Active loading indicator" />
				{:then result}
					<!-- {#if queryRes.length > 0} -->
					<DataTable
						bind:selectedRowIds
						batchSelection
						zebra
						rows={queryRes}
						{headers}
						sortable
					>
						<Toolbar>
							<ToolbarBatchActions>
								<Button
									icon={TrashCan32}
									on:click={batchActionsClick}>Delete</Button
								>
							</ToolbarBatchActions>
							<ToolbarContent>
								<!-- <ToolbarSearch /> -->
								<Button on:click={() => navigate("makebooking")}
									>Faire une nouvelle réservation</Button
								>
							</ToolbarContent>
						</Toolbar>
						<span slot="cell" let:cell let:row>
							{#if cell.key === "buttons"}
								<!-- <Button
									kind="ghost"
									iconDescription="edit"
									icon={Edit32}
									on:click={() => edit(row)}
									disabled={row.start_time < DateTime.now()}
								/> -->
								<Button
									kind="ghost"
									iconDescription="Delete"
									icon={TrashCan32}
									on:click={() => deletesingle(row)}
									disabled={row.start_time < DateTime.now()}
								/>
							{:else}
								{cell.display
									? cell.display(cell.value)
									: cell.value}
							{/if}
						</span>
					</DataTable>
				{:catch error}
					<InlineNotification
						lowContrast
						kind="error"
						subtitle={error.message}
						title="Erreur"
						hideCloseButton
					/>
				{/await}
			</Column>
		</Row>
	{/if}
</Grid>
